import React, { useState } from "react";
import locationimage from "../../assets/location-image.jpg";
import faceauthimage from "../../assets/face-auth-image.jpg";
import documentImage from "../../assets/document-image.jpg";
import documentImageCDT from "../../assets/document-image-cdt.jpg";

interface PhonePreviewProps {
  styles: {
    backgroundColor: string;
    textColor: string;
    buttonColor: string;
    buttonLabelColor: string;
    initialText?: string;
    finalText?: string;
  };
  logoUrl?: string;
}

const PhonePreview: React.FC<PhonePreviewProps> = ({ styles, logoUrl }) => {
  const screens: ("cpf" | "location" | "face" | "document" | "finish")[] = [
    "cpf",
    "location",
    "face",
    "document",
    "finish",
  ];
  const [currentScreenIndex, setCurrentScreenIndex] = useState(0);
  const screen = screens[currentScreenIndex];

  const handleNext = () => {
    setCurrentScreenIndex((prev) => (prev + 1) % screens.length);
  };

  const handlePrevious = () => {
    setCurrentScreenIndex(
      (prev) => (prev - 1 + screens.length) % screens.length
    );
  };

  const renderFinishScreen = () => (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: 15,
        height: "100%",
        justifyContent: "center",
      }}
    >
      <p style={{ color: styles.textColor, fontSize: 14 }}>
        {styles.finalText ||
          "Obrigado por concluir o processo de validação de identidade! Agora é com a gente! Em breve você receberá a atualização do seu status."}
      </p>

      <button
        onClick={() => console.log("Finalizado")}
        style={{
          width: "100%",
          padding: "12px 0",
          backgroundColor: styles.buttonColor,
          border: "none",
          borderRadius: 6,
          color: styles.buttonLabelColor,
          fontWeight: 600,
          fontSize: 16,
          cursor: "pointer",
        }}
      >
        Concluir
      </button>
    </div>
  );

  const renderCPFScreen = () => (
    <div
      style={{
        gap: "15px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        height: "100%",
      }}
    >
      <p style={{ color: styles.textColor, fontSize: 14, marginBottom: 12 }}>
        Olá! NomeDoCliente.{" "}
        {styles.initialText ||
          "Seja bem-vindo à Serasa Experian. Antes de continuarmos com a coleta para autenticar sua identidade, recomendamos que leia a Política de Privacidade sobre como a Serasa Experian trata seus dados pessoais."}
      </p>

      <p
        style={{
          color: styles.textColor,
          fontWeight: "bold",
          fontSize: 15,
          marginBottom: 8,
        }}
      >
        Para começar, informe os 5 primeiros dígitos do seu CPF:
      </p>

      <div style={{ display: "flex", gap: 8, marginBottom: 24 }}>
        {[...Array(5)].map((_, i) => (
          <div
            key={i}
            style={{
              width: 40,
              height: 50,
              border: `1px solid ${styles.textColor}`,
              borderRadius: 6,
            }}
          ></div>
        ))}
      </div>

      <button
        disabled
        style={{
          width: "100%",
          padding: "12px 0",
          backgroundColor: styles.buttonColor,
          border: "none",
          borderRadius: 6,
          color: styles.buttonLabelColor,
          fontWeight: 600,
          fontSize: 16,
          cursor: "not-allowed",
        }}
      >
        Verificar
      </button>
    </div>
  );

  const renderLocationScreen = () => (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        height: "100%",
      }}
    >
      <div style={{ textAlign: "center", marginBottom: 24 }}>
        <img src={locationimage} alt="location" style={{ maxWidth: "100%" }} />
      </div>
      <div>
        <p
          style={{
            color: styles.textColor,
            fontWeight: 600,
            fontSize: 16,
            marginBottom: 8,
          }}
        >
          Compartilhe sua localização
        </p>
        <p
          style={{
            color: styles.textColor,
            fontSize: 14,
            marginBottom: 24,
            textAlign: "justify",
          }}
        >
          Solicitamos essa permissão para aumentar a segurança da sua conta e
          das suas apostas
        </p>
        <button
          style={{
            width: "100%",
            padding: "12px 0",
            backgroundColor: styles.buttonColor,
            border: "none",
            borderRadius: 30,
            color: styles.buttonLabelColor,
            fontWeight: 600,
            fontSize: 16,
          }}
        >
          Compartilhar
        </button>
        <p
          style={{
            textAlign: "center",
            marginTop: 12,
            color: styles.textColor,
            fontWeight: 500,
          }}
        >
          Não Compartilhar
        </p>
      </div>
    </div>
  );

  const renderFaceScreen = () => (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        height: "100%",
      }}
    >
      <p
        style={{
          color: styles.textColor,
          fontWeight: 600,
          fontSize: 18,
          marginBottom: 16,
          textAlign: "center",
        }}
      >
        Autenticação Facial
      </p>
      <div style={{ textAlign: "center", marginBottom: 24 }}>
        <img
          src={faceauthimage}
          alt="face auth"
          style={{ maxWidth: "200px" }}
        />
      </div>
      <ul
        style={{
          color: styles.textColor,
          fontSize: 14,
          paddingLeft: 16,
          marginBottom: 24,
        }}
      >
        <li>Ambiente iluminado</li>
        <li>Não use acessórios</li>
        <li>Rosto centralizado</li>
        <li>Siga as instruções</li>
      </ul>
      <button
        style={{
          width: "100%",
          padding: "12px 0",
          backgroundColor: styles.buttonColor,
          border: "none",
          borderRadius: 30,
          color: styles.buttonLabelColor,
          fontWeight: 600,
          fontSize: 16,
        }}
      >
        Avançar
      </button>
    </div>
  );

  const renderDocumentScreen = () => (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        height: "100%",
      }}
    >
      <p
        style={{
          color: styles.textColor,
          fontWeight: 600,
          fontSize: 18,
          marginBottom: 16,
        }}
      >
        Escolher Documento
      </p>
      <div
        style={{
          backgroundColor: styles.backgroundColor,
          borderRadius: 20,
          padding: 16,
          marginBottom: 12,
          boxShadow: "0 0 0 2px " + styles.textColor,
          display: "flex",
          flexDirection: "row",
          gap: 16,
          alignItems: "center",
        }}
      >
        <div style={{ width: 60 }}>
          <img
            src={documentImage}
            alt="documento físico"
            style={{ width: "100%" }}
          />
        </div>
        <div>
          <p
            style={{
              color: styles.textColor,
              fontWeight: 600,
              marginBottom: 4,
            }}
          >
            Documento Físico
          </p>
          <p style={{ color: styles.textColor, fontSize: 14 }}>
            CNH, RG, DNI, CIN, RNE, RNM
          </p>
        </div>
      </div>
      <div
        style={{
          backgroundColor: styles.backgroundColor,
          borderRadius: 20,
          padding: 16,
          marginBottom: 24,
          display: "flex",
          flexDirection: "row",
          gap: 16,
          alignItems: "center",
        }}
      >
        <div style={{ width: 60 }}>
          <img
            src={documentImageCDT}
            alt="documento digital"
            style={{ width: "100%" }}
          />
        </div>
        <div>
          <p
            style={{
              color: styles.textColor,
              fontWeight: 600,
              marginBottom: 4,
            }}
          >
            Documento Digital
          </p>
          <p style={{ color: styles.textColor, fontSize: 14 }}>
            CDT - Carteira Digital de Trânsito
          </p>
        </div>
      </div>
      <button
        style={{
          width: "100%",
          padding: "12px 0",
          backgroundColor: styles.buttonColor,
          border: "none",
          borderRadius: 30,
          color: styles.buttonLabelColor,
          fontWeight: 600,
          fontSize: 16,
        }}
      >
        Avançar
      </button>
    </div>
  );

  const renderScreen = () => {
    switch (screen) {
      case "location":
        return renderLocationScreen();
      case "face":
        return renderFaceScreen();
      case "document":
        return renderDocumentScreen();
      case "finish":
        return renderFinishScreen();
      default:
        return renderCPFScreen();
    }
  };

  return (
    <div
      style={{
        width: "340px",
        height: "640px",
        borderRadius: "32px",
        boxShadow: "0 4px 20px rgba(0,0,0,0.2)",
        overflow: "hidden",
        border: "8px solid #333",
        backgroundColor: styles.backgroundColor,
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        padding: "40px",
        position: "relative",
      }}
    >
      <div style={{ marginBottom: 24 }}>
        {logoUrl && (
          <img
            src={logoUrl}
            alt="Logo"
            style={{ height: 70, maxWidth: "100%", objectFit: "contain" }}
          />
        )}
      </div>
      {renderScreen()}
      <div
        style={{
          position: "absolute",
          top: "50%",
          left: 8,
          transform: "translateY(-50%)",
          fontSize: 20,
          cursor: "pointer",
          color: styles.textColor,
        }}
        onClick={handlePrevious}
      >
        ◀
      </div>
      <div
        style={{
          position: "absolute",
          top: "50%",
          right: 8,
          transform: "translateY(-50%)",
          fontSize: 20,
          cursor: "pointer",
          color: styles.textColor,
        }}
        onClick={handleNext}
      >
        ▶
      </div>
    </div>
  );
};

export default PhonePreview;
